import { Chart, ChartTimerName } from '@frontend/chart/types';

export const TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: ChartTimerName.TRANSACTION_PICK_UP_PENDING,
            data: [
                { label: '2026-06-01', value: 110000 },
                { label: '2026-07-01', value: 116571 },
                { label: '2026-08-01', value: 122400 }
            ]
        }
    ]
};
